module.exports = __webpack_public_path__ + "static/media/np.d9ad687e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/np.png
// module id = 1946
// module chunks = 0